
import { Component, Prop, Vue } from "vue-property-decorator";
import DataTable from "@/components/dashboard/widgets/DataTable.vue";
import ChartBar from "@/components/dashboard/widgets/ChartBar.vue";
import Number from "@/components/dashboard/widgets/Number.vue";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiDotsVertical, mdiArrowDown, mdiArrowUp, mdiArrowLeft, mdiArrowRight, mdiCircleSmall } from "@mdi/js";
import WidgetData from "@/interfaces/dashboard/WidgetData";

@Component({
  components: {
    SvgIcon,
    DataTable,
    ChartBar,
    Number,
  },
})


export default class Widget extends Vue {

  get displayMenu() {
    return ["LOADED", "ERROR"].includes(this.widgetData.frontEndState);
  }

  get displaySkeleton() {
    return ["PRE_LOADING", "LOADING", "ERROR"].includes(this.widgetData.frontEndState);
  }

  get displayLoading() {
    return ["PRE_LOADING", "LOADING", "ERROR"].includes(this.widgetData.frontEndState);
  }

  get getLoadingColor() {
    if (!this.widgetData.frontEndState) {
      return "#b2b2b2";
    } else if (this.widgetData.frontEndState === "LOADING") {
      return "#fe9303";
    } else if (this.widgetData.frontEndState === "ERROR") {
      return "#FF0000";
    }
  }
  @Prop({ default: {} })
  public widgetData: WidgetData;

  public MAX_WIDGET_PER_ROW = 3;
  public MAX_ROW = 3;

  private mdiDotsVertical = mdiDotsVertical;
  private mdiArrowDown = mdiArrowDown;
  private mdiArrowUp = mdiArrowUp;
  private mdiArrowLeft = mdiArrowLeft;
  private mdiArrowRight = mdiArrowRight;
  private mdiCircleSmall = mdiCircleSmall;

  public isSelected(position, direction) {
    return this.widgetData[direction] === position;
  }

  public changePosition(position, direction) {
    if (this.widgetData[direction] !== position) {
      const widgetDataEdit: any = {};
      widgetDataEdit.id = this.widgetData.id;
      widgetDataEdit.verticalPosition = this.widgetData.verticalPosition;
      widgetDataEdit.horizontalPosition = this.widgetData.horizontalPosition;
      widgetDataEdit[direction] = position;
      this.widgetData.frontEndState = "LOADING";
      return this.$store.dispatch("widgets/editWidget", { widgetId: this.widgetData.id, widgetData: widgetDataEdit })
        .then(() => {
          this.widgetData = Object.assign(this.widgetData, widgetDataEdit);
          this.$set(this.widgetData, "frontEndState", "LOADED");
        })
        .catch(() => this.$set(this.widgetData, "frontEndState", "ERROR"));
    }
  }

  public deleteWidget() {
    if (this.widgetData.id) {
      return this.$store.dispatch("widgets/deleteWidget", { widgetId: this.widgetData.id })
        .then((data) => {
          this.$set(this.widgetData, "frontEndState", "DELETED");
        });
    }

  }
}
